import { Checkbox, Modal, Image } from 'antd';
import { useEffect, useState } from 'react';
interface AutoFillItem {
    label: string,
    value: string
}
interface Props {
    items: AutoFillItem[],
    callback: Function,
    srcType?: string,
    src?: any
}

const AutoCompleteHandler: React.FC<Props> = ({
    items,
    callback,
    srcType,
    src
}) => {


    const [fields, setFields] = useState<any[]>(items);

    useEffect(() => {
        setFields(items);
    }, [items]);



    return (
        <>

            <Modal
                title="Data detected for Auto Fill"
                centered
                open={items.length > 0}
                okText="Auto Fill"
                cancelText="Fill Manually"
                onOk={() => callback(fields)}
                onCancel={() => callback([])}
            >
                <div style={{ width: "100%", height: "400px", overflow: "scroll" }}>
                    {src && <Image preview={{ mask: <></> }} src={URL.createObjectURL(src)}></Image>}
                </div>

                    <Checkbox.Group className='d-block' defaultValue={items.map((item) => item.value)} onChange={(values) => { setFields(items.filter((item) => values.includes(item.value))) }}>

                        {items.map((item, index) => (
                            <div className='my-2 text-lg d-block'><Checkbox key={index} value={item.value}>{item.label} : <b>{item.value}</b></Checkbox></div>
                        ))}

                    </Checkbox.Group>


                <p className='my-2 text-base'>These value are Detected by AI, please <b>Verify</b> before autofilling </p>
            </Modal>

        </>
    )

}

export default AutoCompleteHandler;

